/* import __COLOCATED_TEMPLATE__ from './client-type-step.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class RequestStepsClientTypeStep extends Component {}
